import { Slide } from '@features/powerpoint';

type VisibleSlideOptions = {
  visible: boolean;
  slide: Slide;
};

export const visibleSlide = (options: VisibleSlideOptions) =>
  options.visible ? [options.slide] : [];
